import script from "./CondolenceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CondolenceListView.vue?vue&type=script&setup=true&lang=js"

import "./CondolenceListView.vue?vue&type=style&index=0&id=3b3c7f2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3c7f2d"]])

export default __exports__